import api from '@/logic/api'
import { relaunchApi } from '@/logic/relaunchApi'

export default {
  getCourses: () => relaunchApi.get('/courses'),
  getCourseDetails: (id) => api.get(`/courses/${id}/contents`),
  getContentWBTEvents: (courseId, contentId) => api.get(`/courses/${courseId}/contents/${contentId}/wbt-events`),
  startParticipation: (id) => api.post(`/courses/${id}/participations`),
  getParticipation: (courseId, participationId) => api.post(`/courses/${courseId}/participations/${participationId}`),
  markContentAsPassed: (courseId, participationId, contentId) => api.post(`/courses/${courseId}/participations/${participationId}/passed/${contentId}`),
  answerAttemptAttachment: (courseId, participationId, attemptAttachmentId, answerId) => relaunchApi.post(`/courses/${courseId}/participations/${participationId}/answer-attempt-attachment/${attemptAttachmentId}`, {
    questionAnswerId: answerId,
  }),
  ensureQuestions: (courseId, participationId, contentId) => relaunchApi.post(`/courses/${courseId}/participations/${participationId}/ensure-questions/${contentId}`),
  submitForm: (courseId, participationId, contentId, formId, answerFields) => api.post(`/courses/${courseId}/participations/${participationId}/submit-form/${contentId}/${formId}`, {
    answerFields,
  }),
  repeatAttempt: (courseId, participationId, contentId) => api.post(`/courses/${courseId}/participations/${participationId}/repeat/${contentId}`),
  getCorrectAnswers: (courseId, participationId, contentId, questionId) => api.get(`/courses/${courseId}/participations/${participationId}/correct-answers/${contentId}/${questionId}`),
  requestAccess: (courseId) => api.post(`/courses/${courseId}/access`),
  storeCourseView: (id) => api.post('/view/courses', { id }),
}
